import { render, staticRenderFns } from "./ExternalCommercialAppraisal.vue?vue&type=template&id=cc6aa706&"
import script from "./ExternalCommercialAppraisal.vue?vue&type=script&lang=js&"
export * from "./ExternalCommercialAppraisal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports